import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ModelOperation {
  audit_id: string;
  event_type: string;
  timestamp: string;
  agent_id: number | string | null;
  agent_name: string | null;
  model: string | null;
  status: string | null;
  error_message?: string | null;
}

export interface ModelOperationsResponse {
  count: number;
  logs: ModelOperation[];
  next_cursor?: string | null;
}

@Injectable({
  providedIn: 'root'
})

export class OtaService {
  constructor(private http: HttpClient,) { }

  getOTAJobs(): any {
    const apiUrl = `${environment.host}/ota`;
    return this.http.get(apiUrl);
  }

  getPresignedUploadUrl(fileName: string): any {
    const apiUrl = `${environment.host}/ota/presignUpload?filename=${fileName}`;
    return this.http.get(apiUrl);
  }

  getOTAJobProgress(jobId: number): any {
    const apiUrl = `${environment.host}/ota/${jobId}/progress`;
    return this.http.get(apiUrl);
  }

  cancelOTAJob(jobId: number): any {
    const apiUrl = `${environment.host}/ota/${jobId}/cancel`;
    return this.http.post(apiUrl, {});
  }

  deleteOTAJob(jobId: number): any {
    const apiUrl = `${environment.host}/ota/${jobId}`;
    return this.http.delete(apiUrl);
  }
  getDeviceKms(): any {
    const apiUrl = `${environment.host}/devicekms`;
    return this.http.get(apiUrl);
  }

  createDeviceKmsKey(model: string, keyCount: number, algorithm: string): Observable<any> {
    const apiUrl = `${environment.host}/devicekms`;
    const body = {
      model: model,
      keyCount: keyCount,
      algorithm: algorithm
    };
    
    return this.http.post(apiUrl, body);
  }

  getSignedMetaDetaForModel(model: string): any {
    const apiUrl = `${environment.host}/ota/signed-metadata?model=${model}`;
    return this.http.get(apiUrl);
  }

  getModelOperations(limit: number, cursor?: string): Observable<ModelOperationsResponse> {
    const apiUrl = `${environment.host}/audit-logs`;
    let params = new HttpParams().set('limit', limit.toString());

    if (cursor) {
      params = params.set('cursor', cursor);
    }

    return this.http.get<ModelOperationsResponse>(apiUrl, { params });
  }
}
